import {
  startOfDay,
  endOfDay,
  subDays,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  subWeeks,
  subMonths,
  subYears,
} from "date-fns";

export type DateRange = { from: string; to: string };

export const DEFAULT_PERIOD = "last90Days";

export const periodOptions: {
  value: string;
  label: string;
  range: () => DateRange;
}[] = [
  {
    value: "last90Days",
    label: "Last 90 days",
    range: () => {
      const today = new Date();
      return {
        from: startOfDay(subDays(today, 89)).toISOString(),
        to: endOfDay(today).toISOString(),
      };
    },
  },
  {
    value: "today",
    label: "Today",
    range: () => {
      const today = new Date();
      return {
        from: startOfDay(today).toISOString(),
        to: endOfDay(today).toISOString(),
      };
    },
  },
  {
    value: "yesterday",
    label: "Yesterday",
    range: () => {
      const yesterday = subDays(new Date(), 1);
      return {
        from: startOfDay(yesterday).toISOString(),
        to: endOfDay(yesterday).toISOString(),
      };
    },
  },
  {
    value: "thisWeek",
    label: "This week",
    range: () => {
      const today = new Date();
      return {
        from: startOfWeek(today, { weekStartsOn: 1 }).toISOString(),
        to: endOfWeek(today, { weekStartsOn: 1 }).toISOString(),
      };
    },
  },
  {
    value: "lastWeek",
    label: "Last week",
    range: () => {
      const lastWeek = subWeeks(new Date(), 1);
      return {
        from: startOfWeek(lastWeek, { weekStartsOn: 1 }).toISOString(),
        to: endOfWeek(lastWeek, { weekStartsOn: 1 }).toISOString(),
      };
    },
  },
  {
    value: "thisMonth",
    label: "This month",
    range: () => {
      const today = new Date();
      return {
        from: startOfMonth(today).toISOString(),
        to: endOfMonth(today).toISOString(),
      };
    },
  },
  {
    value: "lastMonth",
    label: "Last month",
    range: () => {
      const lastMonth = subMonths(new Date(), 1);
      return {
        from: startOfMonth(lastMonth).toISOString(),
        to: endOfMonth(lastMonth).toISOString(),
      };
    },
  },
  {
    value: "thisYear",
    label: "This year",
    range: () => {
      const now = new Date();
      return {
        from: startOfYear(now).toISOString(),
        to: endOfYear(now).toISOString(),
      };
    },
  },
  {
    value: "lastYear",
    label: "Last year",
    range: () => {
      const lastYear = subYears(new Date(), 1);
      return {
        from: startOfYear(lastYear).toISOString(),
        to: endOfYear(lastYear).toISOString(),
      };
    },
  },
];

export const getPeriodRange = (value: string): DateRange => {
  const option = periodOptions.find((o) => o.value === value);
  if (!option) {
    throw new Error(`Invalid period value: ${value}`);
  }
  return option.range();
};
